"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment PromoBannerFragment on EditorialPlpPromoBanner {\n    size\n    banner {\n      layout\n      modules {\n        link {\n          title\n          relativeUrl\n        }\n        backgroundVideo {\n          __typename\n          id\n          playInLoop\n        }\n        backgroundImage {\n          url\n        }\n        content {\n          caption\n          title\n        }\n        backgroundStorybookColor\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.promoBannerFragment = void 0;
var _fetching = require("@ori/fetching");
const promoBannerFragment = exports.promoBannerFragment = (0, _fetching.gql)(_templateObject());
